module.exports = __webpack_public_path__ + "img/rede.e0ffef9e.png";